import React from 'react';
import { MainContent } from '../../utilities/mainContent';
import TableData from '../../utilities/table';
import {
  Grid,
  IconButton,
  MenuItem,
  ListItemText,
  ListItemIcon,
  Typography,
  // Drawer,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { MenuButtons } from '../../utilities/menuButton';
// import { DrawerItem } from './drawerItem';
// import { useNavigate } from 'react-router-dom';
// import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { DialogBox } from '../../utilities/dialog';
import { AddCategory } from './addCategory';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import IssueServices from '../../../service/issue';
import { DeleteContent } from '../../../hooks/utils';

const items = [
  {
    label: 'Edit Category',
    icon: <EditIcon fontSize='small' />,
  },
  {
    label: 'Delete Category',
    icon: <DeleteIcon fontSize='small' />,
  },
];

const csvCol = [
  {
    key: 'name',
    label: 'Category Name',
  },
  {
    key: 'status',
    label: 'Status',
  },

  {
    key: 'createdAt',
    label: 'CreatedAt',
  },
  {
    key: 'updatedAt',
    label: 'UpdatedAt',
  },
];

export const CategoryComponent = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isDialog, setIsDialog] = React.useState(false);
  const [setMobileOpens, setMobileOpenss] = React.useState(false);
  const [category, setCategory] = React.useState(null);
  const [filtered, setFiltered] = React.useState(null);
  const [isDelete, setIsDelete] = React.useState(false);
  const queryClient = useQueryClient();

  const { data, isLoading } = useQuery({
    queryKey: ['categories_list_issue'],
    queryFn: () => IssueServices.allCategories(),
  });

  const { mutate } = useMutation({
    mutationFn: IssueServices.category,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['categories_list_issue'] });
      setIsDelete(false);
    },
  });
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const toggleDrawer = () => {
    setMobileOpenss(!setMobileOpens);
  };

  const columns = [
    {
      field: 'name',
      headerName: 'Category Name',
      width: 320,
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 240,
    },

    {
      field: 'createdAt',
      headerName: 'CreatedAt',
      width: 240,
    },
    {
      field: 'updatedAt',
      headerName: 'UpdatedAt',
      width: 240,
    },

    {
      field: '',
      headerName: '',
      width: 20,
      renderCell: (params) => {
        return (
          <Grid container justifyContent='flex-end'>
            <IconButton
              aria-controls={open ? 'fade-menu' : undefined}
              aria-haspopup='true'
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
            >
              <MoreVertIcon />
            </IconButton>
            <MenuButtons
              anchorEl={anchorEl}
              open={open}
              handleClose={handleClose}
              items={items.map((item, index) => (
                <MenuItem
                  key={index}
                  onClick={() => handleMenuItem(item, params)}
                >
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText>
                    <Typography variant='subtitle2'>{item.label}</Typography>
                  </ListItemText>
                </MenuItem>
              ))}
            />
          </Grid>
        );
      },
    },
  ];

  const handleMenuItem = (item, params) => {
    if (item.label === 'Category') {
      toggleDrawer();
      setAnchorEl(null);
    } else if (item.label === 'Edit Category') {
      // navigate('/inspection/edit');
      setAnchorEl(null);
      setIsDialog(() => true);
    } else if (item.label === 'Delete Category') {
      setAnchorEl(null);
      setIsDelete(() => true);
    } else {
      return null;
    }
  };
  return (
    <>
      <MainContent
        csvData={data}
        csvHeaders={csvCol}
        csvDataWithFilter={filtered || data}
        csvHeadersWithFilter={csvCol}
        fileNameWithFilter={'Issue Category list'}
        fileName={'Issue Category list'}
        onChangeSearch={(val) => {
          const searchVal = val?.target?.value || '';
          if (!searchVal) {
            setFiltered(() => data);
            return;
          }
          const value = (data || []).filter(
            (item) => item?.name?.toLowerCase().indexOf(searchVal.toLowerCase()) > -1
          );
          setFiltered(() => value);
        }}
        title='Category'
        items={
          <TableData
            cols={columns}
            maxWidthMob='84vw'
            height='400px'
            isLoading={isLoading}
            rows={filtered || data}
            onRowClick={({ row }) => setCategory(() => row)}
          />
        }
        valueFrom='add_category'
        isBtnName={true}
        btnName={'Add'}
        onBtnNameClick={() => {
          setCategory(null);
          setIsDialog(true);
        }}
      />
      <DialogBox
        handleClose={() => setIsDialog(false)}
        open={isDialog}
        title={
          <Typography variant='subtitle1' component='span'>
            Add Category
          </Typography>
        }
        content={
          <AddCategory
            handleClose={() => setIsDialog(false)}
            category={category}
          />
        }
      />
      <DialogBox
        handleClose={() => setIsDelete(false)}
        open={isDelete}
        maxWidth='500px'
        title={
          <Typography variant='subtitle1' component='span'>
            Delete Issue Category
          </Typography>
        }
        content={
          <DeleteContent
            title='Are you sure you want to delete this category ?'
            onCancel={() => setIsDelete(false)}
            onSubmit={() => {
              const id = category.id;
              const method = 'delete';
              mutate({ id, method });
            }}
          />
        }
      />
    </>
  );
};
